import angular from "angular";

angular
    .module('app')
    .component('attachFieldToClient', {
        template: require('./attach-field-to-client.html'),
        controller: ['$http', 'notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, notifier) {

    const $ctrl = this;

    $ctrl.$onInit = () => {
        $ctrl.client = $ctrl.resolve.client;

        $ctrl.fields = $ctrl.resolve.fields.filter(field => {
            return $ctrl.resolve.attachedFields.findIndex(attachedField => attachedField.field_id === field.id) === -1;
        });

        $ctrl.editingField = $ctrl.resolve.editingField;

        $ctrl.selectedField = null;
        $ctrl.customTitle = $ctrl.editingField ? $ctrl.editingField.custom_title : null;
        $ctrl.editOnDirectory = $ctrl.editingField ? !!$ctrl.editingField.edit_on_directory : false;
        $ctrl.editOnBooking = $ctrl.editingField ? !!$ctrl.editingField.edit_on_booking : false;
        $ctrl.requiredOnBooking = $ctrl.editingField ? !!$ctrl.editingField.required_on_booking : false;
        $ctrl.defaultValue = $ctrl.editingField ? $ctrl.editingField.default_value : null;
    };

    $ctrl.submit = function () {
        $ctrl.loading = true;

        let params = {
            custom_title: $ctrl.customTitle,
            edit_on_directory: $ctrl.editOnDirectory,
            edit_on_booking: $ctrl.editOnBooking,
            required_on_booking: $ctrl.requiredOnBooking,
            default_value: $ctrl.defaultValue,
        };

        if (! $ctrl.editingField) {
            params['field_id'] = $ctrl.selectedField.id;
            params['field_title'] = $ctrl.selectedField.title;
        }

        $ctrl.close({$value: params});

        // const url = $ctrl.editingField
        //     ? `/clients/${$ctrl.client.id}/update-field/${$ctrl.editingField.id}`
        //     : `/clients/${$ctrl.client.id}/add-field`;
        //
        /*$http
            .post(url, params)
            .then(
                res => {
                    $ctrl.loading = false;

                    $ctrl.close({
                        $value: {
                            id: $ctrl.selectedField ? $ctrl.selectedField.id : null,
                            title: $ctrl.selectedField ? $ctrl.selectedField.title : null,
                            pivot: {
                                custom_title: $ctrl.customTitle,
                                edit_on_directory: $ctrl.editOnDirectory,
                                edit_on_booking: $ctrl.editOnBooking,
                                required_on_booking: $ctrl.requiredOnBooking,
                                default_value: $ctrl.defaultValue,
                            }
                        }
                    });

                    notifier.successNotify('Успешно добавлен', 2000);
                },
                err => {
                    $ctrl.loading = false;
                    notifier.errorResponseNotify(err);
                }
            );*/
    }

}


// WEBPACK FOOTER //
// ./resources/assets/modules/components/attach-field-to-client/attach-field-to-client.js